import { Routes, Route } from 'react-router-dom';
import Layout from '@components/Layout/Layout';
import ScrollToTop from '@components/ScrollToTop';
import HomePage from '@pages/HomePage';
import ProductPage from '@pages/ProductPage';
import ResourcesPage from '@pages/ResourcesPage';
import ContactPage from '@pages/ContactPage';

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="product" element={<ProductPage />} />
          <Route path="resources" element={<ResourcesPage />} />
          <Route path="contact" element={<ContactPage />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
